import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import comp from "../../../images/competencias.png";
const Maintenance = () => {
  const [show, setShow] = useState(true);
  //* Method
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="jumbotron ft-banner">
            <main>
              <h1>Descriptores y perfiles</h1>
              <p className="mb-4 text-muted">
                Desde aquí podrás administrar todas las configuraciones que
                corresponden a Descriptores y perfiles, a continuación te
                mostramos el acceso para el mantenimiento de competencias:
              </p>
              {/* <Button variant="primary" className="rounded-pill"> */}
              <Link
                className="btn btn-primary rounded-pill"
                to="/descriptores-perfiles/competencias"
              >
                Agregar competencias
              </Link>
              {/* </Button> */}
            </main>
            <div className="figure">
              <img src={comp} alt="descriptores y perfiles" />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Maintenance;
